export const prepareCssValue = (value: string | number, units: string = 'px') =>
  (typeof value === 'string') ? value : `${value}${units}`

export const setBodyBackgroundColor = (color: string) =>
  document.body.style.backgroundColor = color
